// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2fJ3GLuehdmsblpw5mUAy3 :not.btn {\n  padding-bottom: 1em;\n}\n\n._1hn0bDZEUJma7pAtYCr4od {\n  clear: both;\n  display: flex;\n  width: 100%;\n}\n\n._1hn0bDZEUJma7pAtYCr4od > :first-child {\n  margin: 0 1em;\n  flex: 1;\n}\n\n._35diyvAuEs_VMri0ZtOXjR {\n  margin-left: 5px;\n}\n\n._9KYDcwrovIjaSnkqyWVl2 {\n  width: 100%;\n  font-size: 13px;\n}\n\n._5zyknJnV4SD4H_MhHi4B0 td:first-child {\n  padding: 4px 6px 4px 0;\n}\n\n._2WaCUyBDCPNWcBBCMDBub4 {\n  display: flex;\n  align-items: center;\n}\n\n._2WaCUyBDCPNWcBBCMDBub4 > :nth-child(2) {\n  width: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"timeplanDay": "_2fJ3GLuehdmsblpw5mUAy3",
	"nonEditableTimeplanUnit": "_1hn0bDZEUJma7pAtYCr4od",
	"noTimeplanUnits": "_35diyvAuEs_VMri0ZtOXjR",
	"timeplanUnitSummaries": "_9KYDcwrovIjaSnkqyWVl2",
	"timeplanUnitSummary": "_5zyknJnV4SD4H_MhHi4B0",
	"nonEditableDay": "_2WaCUyBDCPNWcBBCMDBub4"
};
module.exports = exports;
